// extracted by mini-css-extract-plugin
export default {"root":"SnackbarContainer_root__yNtW3"};